import React from 'react';
import './qrcode.css';

function QRCode() {
  return (
    <div 
      className="qrcode-page"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundImage: `url(${process.env.PUBLIC_URL}/qrcodecontest.jpg)`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#000'
      }}
    />
  );
}

export default QRCode;
